export default {
    top_menu: [
        {name:'Principali',    id:0},
        {name:'Mondo dello spettacolo', id:1},
        {name:'Сucinando',  id:2},
        {name:'Politica',   id:3},
        {name:'Speziato',  id:4},
        {name:'Società',   id:5},
        {name:'Salute',   id:6},
    ],
    read_other: 'Per saperne di più',
    read_more:  'Più dettagli',
    not_found:  'Non abbiamo trovato nulla',
    read_also:  'Leggi anche',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Tutti i diritti riservati.',
    subscribe: 'Iscriviti a',

    thank_order: 'GRAZIE PER IL TUO ORDINE',
    specialist_contact: 'Il nostro specialista ti contatterà presto, attendi la nostra chiamata.',
    attention: 'Sconti dai partner:',
    hurry: 'Affrettati, il tempo di attivazione dello sconto è limitato! Hai solo <span id="time" class="time">30:00</span> minuti per scegliere uno di questi prodotti unici:',

    hour_ago1: "Un'ora fa",
    hour_ago2: "ore fa",
    hour_ago3: "ore fa",
    new_publications: "Nuove pubblicazioni",
    read: "Leggi",
    today_at: "Oggi a",
    author_names: ['Stefano Gabbana','Armani Giorgio','Dolce Domenico'],
    main_news: "Principali notizie",
    leave_already: "Già in partenza? Aspetta, abbiamo aggiornato le novità per te",
    already_shared: "già condiviso"
}